// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import GroupClient from "@/api/group/group-client";
const groupClient = new GroupClient();
export default {
  createGroup: async function (context, payload) {
    var result = await groupClient.postAsync(
      {
        url: `${groupClient.url}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updateGroup: async function (context, payload) {
    var result = await groupClient.putAsync(
      {
        url: `${groupClient.url}/${payload.groupId}`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  updatePolicyGroup: async function (context, payload) {
    var result = await groupClient.putAsync(
      {
        url: `${groupClient.url}/${payload.groupId}/update`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },

  deleteGroup: async function (context, payload) {
    var result = await groupClient.deleteAsync(
      {
        url: `${groupClient.url}/${payload.id}?enabled=false`,
      },
      true
    );
    return result;
  },

  getGroup: async function (context, payload) {
    var result = await groupClient.getAsync(
      {
        url: `${groupClient.url}/${payload.id}`,
        data: payload,
      },
      true
    );
    if (result && result.data) {
      return result.data;
    }
    return null;
  },

  getGroups: async function (context, payload) {
    var result = await groupClient.getAsync(
      {
        url: `${groupClient.url}/search`,
        queries: payload,
      },
      true
    );
    if (result && result.data) {
      context.commit("updateGroups", result.data);
      return result.data;
    }
    return null;
  },

  moveToGroupOther: async function (context, payload) {
    var result = await groupClient.putAsync(
      {
        url: `${groupClient.url}/move`,
        data: payload,
      },
      true
    );
    if (result) {
      return result;
    }
    return null;
  },
};
